module.exports = __webpack_public_path__ + "static/q6_x-43903f3125e006578a6d55364d2a7004.png";